import * as Report from '../constants/report.constant'
import * as App from '../constants/app.constant'
import { fromPromise } from 'rxjs/observable/fromPromise'
import { from } from 'rxjs/observable/from'
import { switchMap, map, catchError } from 'rxjs/operators'
import { ofType } from 'redux-observable'

const getDayTrainingLogs = action$ => {
  return action$.pipe(
    ofType(Report.GET_REPORT_LOGS),
    map((action: any) => action.payload),
    switchMap((payload: any) =>
      fromPromise(Promise.resolve()).pipe(
        map(result => ({
          type: Report.GET_REPORT_LOGS_SUCCESS,
          payload: result,
        })),
        catchError(error =>
          from([
            { type: Report.GET_REPORT_LOGS_FAILURE, payload },
            { type: App.SHOW_ERROR, payload: error.message },
          ])
        )
      )
    )
  )
}

const getDayTrainingLogDetails = action$ => {
  return action$.pipe(
    ofType(Report.GET_REPORT_LOG_DETAILS),
    map((action: any) => action.payload),
    switchMap((payload: any) =>
      fromPromise(Promise.resolve()).pipe(
        map(result => ({
          type: Report.GET_REPORT_LOG_DETAILS_SUCCESS,
          payload: result,
        })),
        catchError(error =>
          from([
            { type: Report.GET_REPORT_LOG_DETAILS_FAILURE, payload },
            { type: App.SHOW_ERROR, payload: error.message },
          ])
        )
      )
    )
  )
}

export default [getDayTrainingLogs, getDayTrainingLogDetails]



// WEBPACK FOOTER //
// ./src/epics/report.epic.ts